export const darkGrey = {
  50: '#111111',
  100: '#191919',
  150: '#1D1D1D',
  200: '#222222',
  250: '#2A2A2A',
  300: '#292929',
  600: '#484848',
}
